import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { TpaInput } from '@/lib/api/domains/tpas';
import { keys } from '@/lib/query-keys';

export function useCreateTpa() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TpaInput) => api.tpas.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: keys.tpas.lists(),
      });
    },
  });
}
